// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6556":"css/app.6753","9449":"css/admin-app.6753"}[chunkId] + ".css";
};